import { IoIosSearch } from 'react-icons/io';

import styled from 'styled-components';

import Input from 'components/Input';

export const Container = styled.section`
  padding: 8px 0;
`;

export const NameInput = styled(Input)`
  * > input {
    padding-right: 50px;

    @media ${({ theme }) => theme.device.desktop} {
      font-size: 14px;
    }
  }

  border-color: ${({ theme }) => theme.filters.line};

  &::placeholder {
    color: ${({ theme }) => theme.filters.placeHolder};
  }
`;

export const SearchIcon = styled(IoIosSearch)`
  position: absolute;
  right: 15px;
  top: 0;
  bottom: 0;
  margin: auto;
  font-size: 20px;
  color: ${({ theme }) => theme.filters.icon} !important;
`;
